module.exports = __webpack_public_path__ + "static/media/mobile-booking-calendar.b7a96d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/mobile-booking-calendar.png
// module id = 1219
// module chunks = 27